import { useCallback, useState, type FocusEvent, type KeyboardEvent } from 'react';

/**
 * Caps Lock açık mı — yalnız o alan odaktayken.
 *
 * Şifre alanı yazdığını göstermediği için büyük harf kilidi en sık görülen "şifrem
 * yanlış" sebebi: kullanıcı üç kez deniyor, dördüncüde hesabı kilitleniyor. Tarayıcı
 * kilidin durumunu ancak bir KLAVYE OLAYIYLA söylüyor (`getModifierState`); bu yüzden
 * uyarı ilk tuşta beliriyor, alan odaklanır odaklanmaz değil.
 *
 * Odaktan çıkınca uyarı da kalkar: başka bir alana geçen kullanıcının önünde asılı
 * kalan uyarı, artık geçerli olmayan bir durumu anlatır.
 */
export function useCapsLock() {
  const [on, setOn] = useState(false);

  const read = useCallback((e: KeyboardEvent | FocusEvent) => {
    const native = 'getModifierState' in e ? e : null;
    if (native && typeof (native as KeyboardEvent).getModifierState === 'function') {
      setOn((native as KeyboardEvent).getModifierState('CapsLock'));
    }
  }, []);

  return {
    capsLock: on,
    /** Doğrudan input'a yayılır */
    capsProps: {
      onKeyDown: read,
      onKeyUp: read,
      onBlur: () => setOn(false),
    },
  };
}
